import { WebsiteScrapeConfigCrawlMode } from '@vendasta/embeddings';

export const modeOptions = [
  {
    value: WebsiteScrapeConfigCrawlMode.WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_SINGLE,
    label: 'AI_ASSISTANT.KNOWLEDGE_ACCESS.MODE_SINGLE',
  },
  {
    value: WebsiteScrapeConfigCrawlMode.WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_RECURSIVE,
    label: 'AI_ASSISTANT.KNOWLEDGE_ACCESS.MODE_RECURSIVE',
  },
  {
    value: WebsiteScrapeConfigCrawlMode.WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_SITEMAP,
    label: 'AI_ASSISTANT.KNOWLEDGE_ACCESS.MODE_SITEMAP',
  },
];
